import React from "react";
import { Row, Col, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import storage from "../../../Storage";
import { forceSatoshiFormat, __ } from "../../../Helper";
import C from "../../../Constant";
import GameModal from "../../Components/Game/Stat/Modal";
import { userUID } from "../../../Auth";

class History extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, effect: "zoomIn" });
  }

  handleClose() {
    this.setState({ show: false, effect: "zoomOut" });
  }

  render() {
    return (
      <>
        <button
          style={{
            cursor: "pointer",
            marginRight: "0.5rem",
            width: "2.75rem",
            height: "2.75rem",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            color: "#aeb4ce",
            justifyContent: "center",
          }}
          className={"btn  "}
          onClick={(e) => this.handleShow(e)}
        >
          <i
            style={{ height: "20px", width: "20px" }}
            className="mdi mdi-history mr-1"
          />
          History
        </button>

        <Modal
          size="lg"
          backdrop="static"
          centered={true}
          show={this.state.show}
          onHide={this.handleClose}
          aria-labelledby="history-modal"
          className={"animated " + this.state.effect}
          dialogClassName="custom-history-modal-width"
        >
          <Modal.Header className="history-header border-0 pb-2 position-relative">
            <div className="w-100 text-center">
              <Modal.Title className="text-white fw-bold mb-0 d-flex align-items-center justify-content-center">
                <i className="mdi mdi-history me-2"></i>
                Keno Game History
              </Modal.Title>
            </div>
            <button
              type="button"
              className="custom-close-btn"
              onClick={this.handleClose}
              aria-label="Close"
            >
              <i className="mdi mdi-close"></i>
            </button>
          </Modal.Header>

          <Modal.Body className="history-body p-0">
            <Parent engine={this.props.engine} clicked={this.handleClose} />
          </Modal.Body>
        </Modal>

        <style jsx>{`
          .custom-history-modal-width {
            max-width: 600px !important;
            margin: 1.75rem auto;
          }

          .history-header {
            background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            padding: 1rem 1.5rem;
          }

          .history-body {
            background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
            color: white;
            max-height: 500px;
            overflow-y: auto;
          }

          .custom-close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 32px;
            height: 32px;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 6px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 16px;
          }

          .custom-close-btn:hover {
            background: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.3);
            transform: scale(1.05);
          }

          .custom-close-btn:active {
            transform: scale(0.95);
          }

          .modal-content {
            border: none;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
          }

          .animated.zoomIn {
            animation: zoomIn 0.3s ease-out;
          }

          .animated.zoomOut {
            animation: zoomOut 0.3s ease-in;
          }

          @keyframes zoomIn {
            from {
              opacity: 0;
              transform: scale(0.3);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes zoomOut {
            from {
              opacity: 1;
              transform: scale(1);
            }
            to {
              opacity: 0;
              transform: scale(0.3);
            }
          }
        `}</style>
      </>
    );
  }
}

class Parent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      players: [],
      game_id: "",
      numbers: "",
      hash: "",
      md5: "",
    };
  }

  onChange(event, players, hash, md5, game_id, numbers) {
    this.setState({
      md5: md5,
      hash: hash,
      numbers: numbers,
      game_id: game_id,
      players: players,
      color: numbers >= 1.9 ? "success" : "danger",
    });
  }

  render() {
    const { players, hash, md5, game_id, numbers } = this.state;
    return (
      <Child
        engine={this.props.engine}
        clicked={this.props.clicked.bind(this)}
        onChange={this.onChange.bind(
          this,
          players,
          hash,
          md5,
          game_id,
          numbers
        )}
      />
    );
  }
}

class Child extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      historyRow: [],
      players: [],
      game_id: "",
      busted: "",
      hash: "",
      color: "",
      md5: "",
    };
  }

  componentDidMount() {
    this._isMounted = true;

    let { engine } = this.state;

    engine.getStatus();
    engine.on(C.STATUS_KENO, (data) => this.gameSync(data));
    engine.on(C.BUSTED_KENO, (data) => this.makeList(data));
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  makeList(data) {
    if (this._isMounted) {
      let busted = data.crash;
      let color = "white";
      let numbers, won, amount;

      data.players.forEach((data, i) => {
        if (parseFloat(data.uid) === parseFloat(userUID())) {
          numbers = data.crash;
          amount = forceSatoshiFormat(data.amount);
          won = "-" + forceSatoshiFormat(data.amount);
          color = "danger";
        }
      });

      data.winners.forEach((data, i) => {
        if (parseFloat(data.uid) === parseFloat(userUID())) {
          numbers = data.crash;
          amount = forceSatoshiFormat(data.amount);
          won = forceSatoshiFormat(data.amount);
          color = "success";
        }
      });

      let row = (
        <Block
          clicked={this.props.clicked}
          numbers={numbers}
          won={won}
          amount={amount}
          players={data.players}
          hash={data.hash}
          md5={data.md5}
          game_id={data.game_id}
          busted={busted}
          color={color}
        />
      );

      this.state.historyRow.unshift(row);

      this.setState({
        game_id: data.game_id,
        players: data.players,
        hash: data.hash,
        md5: data.md5,
        busted: busted,
        color: color,
      });

      this.props.onChange(data);
    }
  }

  gameSync(list) {
    if (this._isMounted) {
      let data = list.crashes;

      data.forEach((array, i) => {
        let numbers, won, amount;
        let color = "white";

        array.players.forEach((data, i) => {
          if (parseFloat(data.uid) === parseFloat(userUID())) {
            numbers = data.crash;
            amount = forceSatoshiFormat(data.amount);
            won = "-" + forceSatoshiFormat(data.amount);
            color = "danger";
          } else {
            numbers = "-";
            amount = "-";
            won = "-";
          }
        });

        array.winners.forEach((data, i) => {
          if (parseFloat(data.uid) === parseFloat(userUID())) {
            numbers = data.crash;
            amount = forceSatoshiFormat(data.amount);
            won = forceSatoshiFormat(data.amount);
            color = "success";
          } else {
            numbers = "-";
            amount = "-";
            won = "-";
          }
        });

        let row = (
          <Block
            clicked={this.props.clicked}
            numbers={numbers}
            won={won}
            amount={amount}
            players={array.f}
            hash={array.hash}
            md5={array.md5}
            game_id={array.game_id}
            busted={array.crash}
            color={color}
          />
        );

        this.setState((state) => ({ historyRow: [row, ...state.historyRow] }));

        this.props.onChange(array);
      });
    }
  }

  render() {
    this.state.historyRow.length = 20;
    return (
      <>
        <div className="history-header-row p-3 border-bottom border-secondary">
          <Row className="align-items-center">
            <Col xs="6" className="text-white fw-bold">
              <i className="mdi mdi-identifier me-2"></i>
              Game ID
            </Col>
            <Col xs="6" className="text-center text-white fw-bold">
              <i className="mdi mdi-lock me-2"></i>
              SHA256 Hash
            </Col>
          </Row>
        </div>
        <div
          className="history-list-keno p-2"
          style={{ maxHeight: "400px", overflowY: "auto" }}
        >
          {this.state.historyRow.length > 0 ? (
            this.state.historyRow
          ) : (
            <div className="text-center py-4 text-muted">
              <i className="mdi mdi-history display-4 mb-3"></i>
              <p>No game history available</p>
            </div>
          )}
        </div>

        <style jsx>{`
          .history-header-row {
            background: rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(10px);
          }

          .history-list-keno::-webkit-scrollbar {
            width: 6px;
          }

          .history-list-keno::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 3px;
          }

          .history-list-keno::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 3px;
          }

          .history-list-keno::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.5);
          }
        `}</style>
      </>
    );
  }
}

class Block extends React.Component {
  handleModal(md5, hash) {
    Swal.fire({
      title: "Game Verification",
      html:
        "<div class='text-start'>" +
        "<label class='form-label fw-bold text-info'><i class='mdi mdi-lock'></i> SHA256 Hash</label>" +
        '<input type="text" class="form-control bg-dark text-white border-secondary mb-3" value="' +
        hash +
        '" readonly>' +
        '<label class="form-label fw-bold text-warning"><i class="mdi mdi-key"></i> MD5 Hash</label>' +
        '<input type="text" class="form-control bg-dark text-white border-secondary" value="' +
        md5 +
        '" readonly>' +
        "</div>",
      background: "#1a1a2e",
      color: "#fff",
      confirmButtonColor: "#0f3460",
      confirmButtonText: '<i class="mdi mdi-check"></i> Got it!',
    });
  }

  render() {
    function createMarkup(numbers) {
      let res = "";
      let dotted = "";

      if (!__.isUndefined(numbers)) {
        if (__.isArray(numbers)) {
          if (numbers.length > 3) {
            dotted = "...";
            numbers.length = 3;
          }
          numbers.forEach((number, i) => {
            res +=
              '<div class="avatar-box thumb-xs align-self-center">\n' +
              '<span class="avatar-title bg-soft-info rounded-circle text">' +
              number +
              "</span>\n" +
              "</div>";
          });
        }
      }
      return { __html: res + dotted };
    }

    let { game_id, color, amount, won, numbers, hash, md5 } = this.props;

    return (
      <div
        className="history-row-item mb-2 p-2 rounded"
        style={{ background: "rgba(255,255,255,0.03)" }}
      >
        <Row className="align-items-center">
          <Col xs="6" className="d-flex align-items-center">
            <GameModal
              clicked={this.props.clicked}
              game_id={game_id}
              title={game_id}
              color={color}
            />
          </Col>
          <Col xs="6">
            <div
              className="hash-display p-2 rounded cursor-pointer d-flex align-items-center"
              onClick={() => {
                this.handleModal(md5, hash);
              }}
              style={{
                background: `rgba(${
                  color === "success"
                    ? "40, 167, 69"
                    : color === "danger"
                    ? "220, 53, 69"
                    : "108, 117, 125"
                }, 0.1)`,
                border: `1px solid rgba(${
                  color === "success"
                    ? "40, 167, 69"
                    : color === "danger"
                    ? "220, 53, 69"
                    : "108, 117, 125"
                }, 0.2)`,
                transition: "all 0.2s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = `rgba(${
                  color === "success"
                    ? "40, 167, 69"
                    : color === "danger"
                    ? "220, 53, 69"
                    : "108, 117, 125"
                }, 0.2)`;
              }}
              onMouseLeave={(e) => {
                e.target.style.background = `rgba(${
                  color === "success"
                    ? "40, 167, 69"
                    : color === "danger"
                    ? "220, 53, 69"
                    : "108, 117, 125"
                }, 0.1)`;
              }}
            >
              <i className="mdi mdi-eye me-2 text-muted"></i>
              <span
                className="text-white font-monospace"
                style={{ fontSize: "12px" }}
              >
                {hash.substr(0, 20)}...
              </span>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default History;
